module.exports = __webpack_public_path__ + "static/media/whiteCloseButtonIcon.52513ff7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/whiteCloseButtonIcon.svg
// module id = 108
// module chunks = 27